import React from "react";
import "./PricingPage.scss";
import {
    CheckCircleFilled,
    ThunderboltFilled,
    CalendarFilled,
    ToolFilled,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const rosteringFeatures = [
    "Employee Rostering",
    "Clock In / Clock Out",
    "Shift Swaps",
    "Leave Management",
    "Timesheets",
    "Timesheet Approval",
    "Staff Availability",
    "Mobile Access",
    "Notifications",
    "Reporting",
    "Xero Payroll Integration",
];

const tradeFeatures = [
    "Unlimited Jobs",
    "Quotes",
    "Invoices",
    "Customer Management",
    "Job Scheduling",
    "Staff Allocation",
    "Job Notes",
    "Photos & Attachments",
    "Materials Tracking",
    "Profit Tracking",
    "Mobile Access",
    "Reporting",
];

export default function PricingPage() {
    const navigate = useNavigate();
    return (
        <div className="pricing-page">
            <div className="about-us-top-actions">
          <button type="button" className="about-us-top-button about-us-top-button-secondary" onClick={() => navigate('/home')}>
            Home
          </button>
         
        </div>
            <section className="hero">
                <div className="hero-content">
                    
                    <h1>
                        Simple pricing for small businesses
                        <span> without enterprise pricing</span>
                    </h1>

                    <p>
                        Your rostering, leave, timesheets, work coordination and payroll integrations all in one
                    </p>

                    <div className="hero-buttons">
                        <button className="btn-primary"  onClick={() => navigate('/contact-us')}>
                            Book A Demo
                        </button>

                        <button className="btn-secondary" onClick={() => navigate('/start?auth=signUp')}>
                            Join Free
                        </button>
                    </div>
                </div>
            </section>

            <section className="pricing-section">
                <div className="pricing-grid">

                    {/* Rostering */}

                    <div className="pricing-card">
                        <div className="icon">
                            <CalendarFilled />
                        </div>

                        <h2>Rostering</h2>

                        <div className="price">
                            $6.50
                            <span>/user/month</span>
                        </div>

                        <p className="description">
                            Complete workforce management for growing teams.
                        </p>

                        <ul>
                            {rosteringFeatures.map((item) => (
                                <li key={item}>
                                    <CheckCircleFilled />
                                    {item}
                                </li>
                            ))}
                        </ul>

                        <button className="card-btn">
                            Get Started
                        </button>
                    </div>

                    {/* Trade */}

                    <div className="pricing-card featured">
                        <div className="popular-badge">
                            MOST POPULAR
                        </div>

                        <div className="icon">
                            <ToolFilled />
                        </div>

                        <h2>Trade Job Management</h2>

                        <div className="price">
                            $9.50
                            <span>/user/month</span>
                        </div>

                        <p className="description">
                            Manage jobs from quote through to invoice.
                        </p>

                        <ul>
                            {tradeFeatures.map((item) => (
                                <li key={item}>
                                    <CheckCircleFilled />
                                    {item}
                                </li>
                            ))}
                        </ul>

                        <button className="card-btn">
                            Get Started
                        </button>
                    </div>

                </div>
            </section>

            <section className="comparison">
                <div className="container">
                    <h2>
                        Why Effiez Rostering
                    </h2>

                    <table>
                        <thead>
                            <tr>
                                <th>Feature</th>
                                <th>Effiez</th>
                                <th>Deputy</th>
                                <th>MYOB Team</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>Rostering</td>
                                <td>✓</td>
                                <td>✓</td>
                                <td>✓</td>
                            </tr>

                            <tr>
                                <td>Clock In/Out</td>
                                <td>✓</td>
                                <td>✓</td>
                                <td>✓</td>
                            </tr>

                            <tr>
                                <td>Shift Swaps</td>
                                <td>✓</td>
                                <td>✓</td>
                                <td>—</td>
                            </tr>

                            <tr>
                                <td>Leave Management</td>
                                <td>✓</td>
                                <td>✓</td>
                                <td>✓</td>
                            </tr>

                            <tr>
                                <td>Xero Payroll</td>
                                <td>✓</td>
                                <td>✓</td>
                                <td>—</td>
                            </tr>

                            <tr>
                                <td>Starting Price</td>
                                <td>$6.50</td>
                                <td>Higher</td>
                                <td>Higher</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <section className="comparison">
                <div className="container">
                    <h2>
                        Why Effiez Trade Job Management
                    </h2>

                    <table>
                        <thead>
                            <tr>
                                <th>Feature</th>
                                <th>Effiez</th>
                                <th>Tradify</th>
                                <th>ServiceM8</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>Unlimited Jobs</td>
                                <td>✓</td>
                                <td>✓</td>
                                <td>✓</td>
                            </tr>

                            <tr>
                                <td>Quotes</td>
                                <td>✓</td>
                                <td>✓</td>
                                <td>✓</td>
                            </tr>

                            <tr>
                                <td>Invoices</td>
                                <td>✓</td>
                                <td>✓</td>
                                <td>✓</td>
                            </tr>

                            <tr>
                                <td>Scheduling</td>
                                <td>✓</td>
                                <td>✓</td>
                                <td>✓</td>
                            </tr>

                            <tr>
                                <td>Profit Tracking</td>
                                <td>✓</td>
                                <td>Limited</td>
                                <td>Limited</td>
                            </tr>

                            <tr>
                                <td>Starting Price</td>
                                <td>$9.50</td>
                                <td>Higher</td>
                                <td>Higher</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <section className="cta">
                <ThunderboltFilled />

                <h2>
                    Ready to simplify your business?
                </h2>

                <p>
                    Join businesses managing staff and jobs
                    with Effiez.
                </p>

                <button onClick={() => navigate('/contact-us')}>
                    Book Your Demo
                </button>
            </section>
        </div>
    );
}